import { render, staticRenderFns } from "./rule-detail.vue?vue&type=template&id=5f822fe6&scoped=true&"
import script from "./rule-detail.vue?vue&type=script&lang=ts&"
export * from "./rule-detail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f822fe6",
  null
  
)

export default component.exports